import classNames from 'classnames'

import styles from './loader-circle.module.css'

type LoaderCircleProps = {
  className?: string
}

export const LoaderCircle = ({ className }: LoaderCircleProps) => {
  const ringPrfx = styles.ring
  const ringCls = classNames(ringPrfx, {
    [`${className}`]: className
  })
  return (
    <div className={ringCls}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}
